import { StudentLCReport } from '../types';

export const transformStudentLcReportData = (
  studentLcReportData: StudentLCReport[],
  isDownloading: boolean = false
) => {
  return studentLcReportData.map((report) => {
    const basicData = {
      'Enrollment No': report.enrollmentNo,
      Name: report.name,
      Email: report.email,
      'Academic Year': report.academicYear,
      'Last Grade': report.lastGrade,
      'Last Division': report.lastDivision,
      'LC Requested Date': report.lcRequestedDate,
      'LC Generated Date': report.lcGeneratedDate,
      Progress: report.progress,
      'General Conduct': report.generalConduct,
      'Date of Leaving': report.dateOfLeaving,
      'Reason of Leaving': report.reasonOfLeaving,
      'Passed And Promoted To Class': report.passedAndPromotedToClass,
      'Detained In Class': report.detainedInClass,
      Remarks: report.remarks
    };
    if (!isDownloading) {
      return { id: report.id, ...basicData };
    }
    return basicData;
  });
};
